import { calculateCandidateLikelihoodPercentage } from "../../../../utils/Constants/jobApplicationProcessSteps"
import useTheme from "../../../../hooks/useTheme";
import { getUserName } from "../../../../utils/helperFunctions"
import { AppColumn, AppRow } from "../../../UI/Layouts"
import AppText from "../../../UI/Texts/AppTexts"
import { SizedBox } from "../../../UI/Sizes"
import { t } from "i18next"
import { UserAvatar } from "../../../UI/DisplayImage"
import { useResponsive } from "../../../UI/ResponsiveContext"
import { MODAL_BOTTOM_SHEET } from "../../../UI/Sheet/BottomSheet"
import { APP_MODAL } from "../../../Modals/AppModal"
import ContactPersonProfileSheet from "./ContactPersonProfileSheet"


const HirePossibility = ({ mainPages, contactPerson, openModal }) => {
    const theme = useTheme();
    const { isMobile } = useResponsive();


    const possibility = calculateCandidateLikelihoodPercentage({ steps: mainPages })

    let possibilityTitle = t('well_done')
    let possibilityText = t('candidatedetail.hire_possibility.present')

    if (possibility.percentage >= 100) {
        possibilityTitle = t('congratulations')
        possibilityText = t('candidatedetail.hire_possibility.100%')
    }


    return (
        <AppRow
            mainAxisAlignment={'space-between'}
            crossAxisAlignment={'start'}
        >
            <AppRow
                mainAxisAlignment={'start'}
                crossAxisAlignment={'start'}
                style={{ cursor: contactPerson && openModal ? 'pointer' : 'default' }}
                onClick={() => {
                    if (contactPerson && openModal) {
                        const content = <ContactPersonProfileSheet contactPerson={contactPerson} />;
                        if (isMobile) {
                            openModal(MODAL_BOTTOM_SHEET, {
                                height: 50,
                                children: content,
                            });
                        } else {
                            openModal(APP_MODAL, {
                                width: '420px',
                                padding: '0',
                                children: content,
                            });
                        }
                    }
                }}
            >
                {contactPerson && <AppRow>
                    <UserAvatar
                        url={contactPerson?.profileImageUrl}
                        name={getUserName(contactPerson)}
                        style={{
                            aspectRatio: '1',
                            height: isMobile
                                ? theme.sizing.applicationContactAvatarMobile
                                : theme.sizing.applicationContactAvatarDesktop,
                            width: isMobile
                                ? theme.sizing.applicationContactAvatarMobile
                                : theme.sizing.applicationContactAvatarDesktop,
                        }}
                    />
                    <SizedBox width={theme.spacing.elementPaddingSmall} />
                </AppRow>}

                <AppColumn style={{
                    flex: 1,
                }}>
                    <AppText.Caption
                        fontWeight={600}
                    >
                        {possibilityTitle}
                    </AppText.Caption>
                    <SizedBox height={'0.25rem'} />
                    <AppText.Footnote
                        color={theme.colors.dark}
                        style={{
                            flex: 1,
                        }}>
                        {possibilityText}
                    </AppText.Footnote>

                </AppColumn>
            </AppRow>
        </AppRow>
    )
}

export default HirePossibility
